import { useMutation } from '@apollo/client'
import { FC } from 'react'
import { useDispatch } from 'react-redux'
import { ArrowRight, X } from 'lucide-react'

import { UNLINK_BOARD } from 'src/graphql/lti'
import useBoardId from 'src/hooks/useBoardId'
import { setBanner } from 'src/store/action-methods/banner'
import Modal from 'src/components/generics/modal'
import { Button, Stack } from 'design-system'

interface UnlinkCommunityModalProps {
  open: boolean
  onModalClose(): void
  onUnlinkSuccess?(): void
  onUnlinkError?(): void
}

export const UnlinkCommunityModal: FC<UnlinkCommunityModalProps> = ({
  open,
  onModalClose,
  onUnlinkSuccess,
  onUnlinkError
}) => {
  const dispatch: $TSFixMe = useDispatch()
  const [unlinkAllBoardLti] = useMutation(UNLINK_BOARD)
  const boardId = useBoardId()

  const unlinkBoardLti = async () => {
    onModalClose()
    const payload = {
      variables: {
        boardId
      }
    }
    try {
      await unlinkAllBoardLti(payload)
      dispatch(
        setBanner({
          open: true,
          msg: 'This community has been successfully unlinked.',
          assertive: true
        })
      )
      if (typeof onUnlinkSuccess === 'function') {
        onUnlinkSuccess()
      }
    } catch (_) {
      dispatch(
        setBanner({
          open: true,
          type: 'error',
          msg: 'We were unable to unlink this community.',
          assertive: true
        })
      )
      if (typeof onUnlinkError === 'function') {
        onUnlinkError()
      }
    }
  }

  return (
    <Modal
      open={open}
      onRequestClose={onModalClose}
      id="unlink-modal"
      title={<p className="text-base font-medium">Confirm</p>}
      large>
      <Stack gap={4} className="p-4">
        <p className="text-base">
          Are you sure want to unlink this community from your LMS? This action
          cannot be undone.
        </p>
        <div className="flex justify-end gap-x-4">
          <Button
            className="min-w-28 justify-between"
            buttonType="secondary"
            buttonSize="xs"
            rightIconSlot={<X />}
            onClick={onModalClose}>
            Cancel
          </Button>
          <Button
            className="min-w-28 justify-between"
            buttonType="red"
            buttonSize="xs"
            rightIconSlot={<ArrowRight />}
            onClick={unlinkBoardLti}>
            Unlink
          </Button>
        </div>
      </Stack>
    </Modal>
  )
}
